<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-03-08 21:14:50
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-29 09:59:45
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="contractNum">
            <el-input
              v-model="filterForm.contractNum"
              placeholder="合同编号"
              style="width: 150px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="trustee" v-if="!$route.query.$businessName">
            <el-input
              v-model="filterForm.trustee"
              placeholder="合作社名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="villageId">
            <el-cascader
              v-model="checkedRegionData"
              :props="regionProps"
              :options="regionData"
              :show-all-levels="false"
              placeholder="所属村"
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="statusFlag">
            <el-select
              v-model="filterForm.statusFlag"
              placeholder="合同状态"
              style="width: 150px"
            >
              <el-option label="全部" value="-1"></el-option>
              <el-option
                v-for="item in uniqeGlobalDict$$['2']"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterPro('filterForm')"
              >查询</el-button
            >
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table :data="contracts" style="width: 100%">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractNum"
          label="合同编号"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="!$route.query.$businessName"
          prop="trustee"
          label="合作社名称"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="villageName"
          label="所属村"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contractAllotted"
          label="合同期限"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contractLandArea"
          label="流转面积（亩）"
          min-width="6%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusFlagName"
          label="合同状态"
          min-width="5%"
          align="center"
        >
        </el-table-column>

        <el-table-column label="操作" min-width="5%" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              round
              @click="handleLookDetail(scope.row)"
              :disabled="scope.row.statusFlag == 30"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
import { mapActions } from 'vuex'
import regionSeatLibs from 'utils/regionSeatLibs'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  $dictKeyList: [
    {
      key: '2',
      name: '合同状态',
    },
  ],
  data() {
    const that = this
    return {
      filterForm: {
        contractType: 3, //2 托管合同 3流转合同
        contractNum: '',
        trustee: '',
        statusFlag: '',
        trusteeAccountId: '',
      },
      regionProps: {
        value: 'i',
        label: 'n',
        children: 'c',
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, children, label, value, data } = node
          // 直辖市的二级（例：海淀区）flag：true代表直辖市
          if (level == 2 && children.length == 0) {
            that.getChildRegion(value, level >= 3, resolve, true)
          }
          if (level == 3 && children.length == 0 && label != '市辖区') {
            let leaf = false
            if (data.flag) {
              leaf = true
            } else {
              leaf = false
            }
            that.getChildRegion(value, leaf, resolve)
          } else if (level >= 4) {
            that.getChildRegion(value, level >= 4, resolve)
          } else {
            resolve()
          }
        },
      },
      regionData,
      checkedRegionData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      contracts: [],
    }
  },
  watch: {
    checkedRegionData(n) {
      this.filterForm.villageId = n[n.length - 1]
    },
  },
  created() {
    this.filterForm.trusteeAccountId = this.$route.query.$businessAccountId
    this.getContractList()
  },
  methods: {
    ...mapActions('addContract', ['setContractInfo']),
    /**
     * @descripttion: 获取地区子级数据
     * @Author: juanjuanhui
     * @Date: 2022-04-02 15:45:04
     * @param {*} value 当前节点的value
     * @param {*} leaf 当前节点的leaf
     * @param {*} resolve
     * @param {*} flag 是否是直辖市的标志 非必传
     */
    getChildRegion(value, leaf, resolve, flag) {
      this.$http.common.getChildRegion({ pid: value }).then((res) => {
        let nodes = res.data
        if (flag) {
          nodes.forEach((item) => {
            item.leaf = leaf
            item.flag = flag
          })
        } else {
          nodes.forEach((item) => {
            item.leaf = leaf
          })
        }
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes)
      })
    },
    /**
     * @descripttion: 获取机手列表
     * @Author: juanjuanhui
     * @Date: 2021-11-23 20:35:33
     * @param {*}
     * @return {*}
     */
    getContractList() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.statusFlag == -1) {
        delete this.allFilters.statusFlag
      }
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.contract.getContractList(params).then((res) => {
        let { recordTotal, content: contracts } = res.data
        this.pagination.recordTotal = recordTotal
        this.contracts = contracts
      })
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.checkedRegionData = []
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getContractList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-24 14:05:16
     * @param {*} params
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/cooperative/transfer/contract/detail',
        query: { id: params.id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .el-table {
    margin-top: 10px;
  }
}
::v-deep {
  .el-dialog {
    .el-dialog__footer {
      padding-top: 0;
      padding-bottom: 40px;
      text-align: center;
    }
  }
  .dialog-add {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 20px 0;
      .title {
        font-size: 22px;
        color: #242424;
        text-align: center;
        font-weight: 900;
      }
      .con {
        padding: 20px 50px 0;
        font-size: 20px;
        color: #444444;
        line-height: 34px;
      }
    }
  }
  .dialog-del {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      .info {
        padding-top: 20px;
        font-size: 20px;
        text-align: center;
        color: #444;
      }
    }
  }
}
</style>
